export default __webpack_public_path__ + "static/media/NoMorePlastics.57dcc4f9.svg";